import React from 'react'

function WhoImarikaChamaa() {
  return (
    <div>

Suitable for formal and informal savings groups (Chamaas) such as investment clubs, investment companies, merry-go-round groups, project groups etc.
<br></br>
<br></br>
It’s ideal for those seeking superior returns for their investments to achieve their goals.
<br></br>
<br></br>
All members in the group should be Kenyan Citizens with a valid national ID or passport and KRA pin number and between the age of 18 and 75 years.



    </div>
  )
}

export default WhoImarikaChamaa